import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import ko_KR from 'antd/es/locale/ko_KR';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { persistor, store } from './store';
import './index.css';

const theme = {
  token: {
    fontFamily: 'Pretendard',
    colorPrimary: '#6032db',
  },
  components: {
    Segmented: {
      itemSelectedColor: '#6032db',
      trackPadding: 3,
    },
  },
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ConfigProvider theme={theme} locale={ko_KR}>
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </ConfigProvider>
);
